// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {
    mapRouteDetails,
    pipSearchViewMap
} from '../../shared/services/pip-search-helper';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';
import PipDaysToExpiryWidget from '../../shared/components/pip-days-to-expiry-widget';
import PipProductSearchResult from '@deere/cps-it.warranty-model-factory/lib/pip-product';
import PipSearchResult from '@deere/cps-it.warranty-model-factory/lib/pip-search-results';

const PipSearchList = props => {

    const SearchResultList = pipSearchViewMap(props.searchByType);

    return (
        <div>
            {props.pips.length || props.busyCounter ?
                <ul>
                    {props.pips.map((pip, index) => {

                        const routeDetails = mapRouteDetails(props.searchByType, pip);

                        return (
                            <li
                                className='pip-search-list'
                                key={index}
                            >
                                <div className='pip-information-container'>
                                    <header>
                                        <Link to={routeDetails.route}>{routeDetails.label}</Link>
                                        {props.searchByType === 'PIN' &&
                                            <span className='pip-completion-status'>{pip.pipCompletionStatus.value}</span>
                                        }
                                        <PipDaysToExpiryWidget
                                            daysLeft={pip.daysRemaining}
                                            metric={pip.metric.key}
                                            pipCompletionStatus={props.searchByType === 'PIN' ? pip.pipCompletionStatus.key : ''}
                                            showIndicatorOnly={false}
                                        />
                                    </header>
                                    <SearchResultList
                                        key={index}
                                        pipProduct={pip}
                                    />
                                </div>
                            </li>
                        );

                    })}
                </ul> :
                <FormattedMessage id='NO_PIP_PRODUCTS'/>
            }
        </div>
    );

};

PipSearchList.displayName = 'PipSearchList';
PipSearchList.propTypes = {
    busyCounter: PropTypes.number.isRequired,
    pips: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.instanceOf(PipProductSearchResult),
        PropTypes.instanceOf(PipSearchResult)
    ])).isRequired,
    searchByType: PropTypes.string.isRequired
};

export default PipSearchList;



// WEBPACK FOOTER //
// ./src/pip/pip-search/components/pip-search-list.js